import {useLocalization} from "@fluent/react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {Divider, IconButton, Stack, Typography} from "@mui/material";
import React from "react";

function NavSubPanel(props: {
	children: NonNullable<React.ReactNode> | React.ReactNode[];
	title: React.ReactNode;
	onBack: () => void;
}) {
	const {l10n} = useLocalization();

	return (
		<>
			<Stack direction="row" spacing={0.5} sx={{alignItems: "center", p: 1}}>
				<IconButton
					aria-label={l10n.getString("nav-label-back")}
					onClick={props.onBack}
				>
					<ArrowBackIcon />
				</IconButton>
				<Typography variant="subtitle1">{props.title}</Typography>
			</Stack>

			<Divider />

			{props.children}
		</>
	);
}

export default NavSubPanel;
